export default __webpack_public_path__ + "static/media/41.98e50364.png";